import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-border bg-input px-3 py-2",
          "text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium",
          // Smooth focus visuals (border + ring) across the app
          "text-foreground placeholder:text-muted-foreground",
          "transition-[border-color,box-shadow,color] duration-150",
          "focus:outline-none focus-visible:outline-none",
          "focus:border-ring focus-visible:border-ring",
          "focus:ring-2 focus-visible:ring-2 focus:ring-ring/30 focus-visible:ring-ring/30",
          "focus:ring-offset-0 focus-visible:ring-offset-0",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
